import React, { FC } from 'react';

import { TxnState } from 'services/nfts';
import { Spinner } from 'components/Spinner';

type Props = {
  txnState: TxnState;
  initialTxnState: TxnState;
};

const getMintingStatus = (txnState: TxnState, initialTxnState: TxnState) => {
  switch (txnState) {
    case 'idle':
    case 'loading':
      return 'Confirm NFT Creation';
    case 'pending':
      return 'Creating NFT';
    case 'error':
    case 'reverted':
      return 'Attempt to create NFT failed';
    case 'success':
      if (initialTxnState === 'success') {
        return 'NFT Details';
      } else {
        return 'NFT Created';
      }
  }
};

export const MintingStateMessage: FC<Props> = ({ txnState, initialTxnState }) => {
  return (
    <div className='minting-state-message'>
      <h2 className='minting-state-message__headline headline headline--medium'>
        {getMintingStatus(txnState, initialTxnState)}
        {txnState === 'pending' ? <Spinner className='d-inline-block ml-1' /> : null}
      </h2>
    </div>
  );
};
